import React, { useRef, useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import '../../styles/scrollbar.css';

const AchievementsDisplay = ({ allAchievements = [] }) => {
    const [dragConstraints, setDragConstraints] = useState({ right: 0, left: 0 });
    const scrollContainerRef = useRef(null);

    useEffect(() => {
        setTimeout(() => {
            if (scrollContainerRef.current) {
                const containerWidth = scrollContainerRef.current.scrollWidth;
                const viewportWidth = scrollContainerRef.current.offsetWidth;
                const padding = 16;
                setDragConstraints({
                    right: 0,
                    left: -(containerWidth - viewportWidth + padding)
                });
            }
        }, 100);
    }, [allAchievements]);

    return (
        <div className="w-full max-w-2xl">
            <div className="relative -mx-4">
                {allAchievements.length === 0 ? (
                    <div className="flex justify-center p-4">Loading achievements...</div>
                ) : allAchievements.length === 0 ? (
                    <div className="text-center text-gray-500">No achievements available yet!</div>
                ) : (
                    <div className="relative">
                        <motion.div 
                            className="flex space-x-2 pb-4 scrollbar-hide snap-x snap-mandatory cursor-grab active:cursor-grabbing"
                            style={{
                                scrollbarWidth: 'none',
                                WebkitOverflowScrolling: 'touch',
                                scrollSnapType: 'x mandatory',
                                paddingLeft: '1rem',
                                touchAction: 'pan-x'
                            }}
                            drag="x"
                            ref={scrollContainerRef}
                            dragConstraints={dragConstraints}
                            dragElastic={0.1}
                            dragTransition={{ bounceStiffness: 600, bounceDamping: 20 }}
                            whileTap={{ cursor: 'grabbing' }}
                        >
                            {allAchievements.map((achievement, index) => {
                                const isEarned = !!achievement.earned;

                                if (achievement.is_card_style) {
                                    return (
                                        <motion.div
                                            initial={{ opacity: 0, y: 20 }}
                                            animate={{ opacity: 1, y: 0 }}
                                            transition={{
                                                duration: 0.3,
                                                delay: index * 0.1
                                            }}
                                            key={achievement.id}
                                            className="flex-none w-[calc(40%-0.5rem)] min-w-[calc(40%-0.5rem)] snap-center aspect-[5/7] rounded-lg shadow-md relative overflow-hidden"
                                        >
                                            {achievement.icon && (
                                                <img
                                                    src={achievement.icon}
                                                    alt={achievement.name}
                                                    draggable={false}
                                                    className={`w-full h-full object-cover ${
                                                        !isEarned && 'grayscale opacity-50'
                                                    }`}
                                                />
                                            )}
                                        </motion.div>
                                    );
                                }

                                return (
                                    <motion.div
                                        initial={{ opacity: 0, y: 20 }}
                                        animate={{ opacity: 1, y: 0 }}
                                        transition={{
                                            duration: 0.3,
                                            delay: index * 0.1 // Stagger the animations
                                        }}
                                        key={achievement.id}
                                        className={`flex-none w-[calc(40%-0.5rem)] min-w-[calc(40%-0.5rem)] snap-center ${
                                            isEarned ? 'bg-white' : 'bg-white opacity-75'
                                        } px-5 py-8 rounded-lg shadow-md relative`}
                                    >
                                        <div className="flex flex-col items-center text-center relative">
                                        {achievement.icon && (
                                            <img
                                                src={achievement.icon}
                                                alt=""
                                                draggable={false}
                                                className={`w-28 h-28 object-cover rounded mb-3 ${
                                                    !isEarned && 'grayscale opacity-50'
                                                }`}
                                            />
                                        )}
                                        <div className="w-full">
                                                <h4 className={`font-extrabold mb-0.5 uppercase ${
                                                        isEarned ? 'text-popashot-blue' : 'text-popashot-grey'
                                                }`}>
                                                {achievement.name}
                                            </h4>
                                            <p className="text-xs text-gray-600 mb-3">
                                                {achievement.description}
                                            </p>
                                            <div className="flex flex-col items-center gap-2">
                                                {/* <span className={`px-2 py-1 text-sm rounded-full ${
                                                        isEarned ? 'bg-popashot-grey-light' : 'text-popashot-grey bg-popashot-grey-light'
                                                }`}>
                                                    +{achievement.points} XP
                                                </span> */}
                                                {/* {isEarned && (
                                                    <span className="text-xs text-gray-500">
                                                        Earned {new Date(achievement.earned_at).toLocaleDateString()}
                                                    </span>
                                                )} */}
                                            </div>
                                        </div>
                                        </div>
                                    </motion.div>
                                );
                            })}
                        </motion.div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default AchievementsDisplay;
